import { render, staticRenderFns } from "./attr-category.vue?vue&type=template&id=0d9275ee&scoped=true&"
import script from "./attr-category.vue?vue&type=script&lang=js&"
export * from "./attr-category.vue?vue&type=script&lang=js&"
import style0 from "./attr-category.vue?vue&type=style&index=0&id=0d9275ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d9275ee",
  null
  
)

export default component.exports